// src/redux/actions/industryActions.js
import {
  FETCH_INDUSTRY_REQUEST,
  FETCH_INDUSTRY_SUCCESS,
  FETCH_INDUSTRY_FAILURE,
  SET_SELECTED_INDUSTRY,
} from '../types';
import axios from '../../API/axios';

export const fetchIndustryData = () => async (dispatch) => {
  dispatch({ type: FETCH_INDUSTRY_REQUEST });

  try {
    const response = await axios.get(`/MasterData/GetFirmIndustryTypesDDL`);
    let industryList =response.data.responseData.map((val)=>{
      return{value:val.id,label:val.name}
  })
    dispatch({
      type: FETCH_INDUSTRY_SUCCESS,
      payload: industryList,
    });
  } catch (error) {
    dispatch({
      type: FETCH_INDUSTRY_FAILURE,
      payload: error.message,
    });
  }
};

export const setSelectedIndustry = (industryId) => ({
  type: SET_SELECTED_INDUSTRY,
  payload: industryId,
});
